import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuál opción me recomendás?',
    a: 'El Bundle Gold. Es la opción que tiene todo: el sistema para el patio Y la solución para el trabajo burocrático. Es el único que te libera completamente de la improvisación en el aula y de las horas perdidas frente a la computadora.'
  }, {
    q: '¿Para qué nivel es el Método A.C.C.I.Ó.N.?',
    a: 'Para Primaria y Secundaria. Los 5 tomos tienen contenido específico para ambos niveles con adaptaciones claras para cada etapa.'
  }, {
    q: '¿Sirve para cualquier provincia de Argentina?',
    a: 'Sí. El Tomo 3 y el Tomo Gold están adaptados a los diseños curriculares de CABA, PBA y los NAP nacionales que aplican a todo el país.'
  }, {
    q: '¿Es un curso o un eBook?',
    a: 'Es una colección de PDFs listos para descargar e imprimir. No hay videos ni plataformas externas. Los abrís en el celular, la tablet o la computadora y los usás inmediatamente.'
  }, {
    q: '¿Cómo funciona la garantía?',
    a: 'Tenés 7 días desde la compra para pedir el reembolso. Mandás un mensaje y te devolvemos el 100% sin preguntas. Así de simple.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-[#0B1A2E] py-20 px-4 text-white" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12" data-id="element-13">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-14">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden transition-all" data-id="element-15">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-16">
                <span className="font-bold text-lg pr-4" data-id="element-17">{faq.q}</span>
                {openIdx === idx ? <ChevronUp className="w-5 h-5 text-[#F0C14B] flex-shrink-0" data-id="element-18" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-19" />}
              </button>

              {openIdx === idx && <div className="px-6 pb-4 text-gray-300" data-id="element-20">
                  <p className="pt-2 border-t border-white/10" data-id="element-21">{faq.a}</p>
                </div>}
            </div>)}
        </div>

        <div className="text-center mt-16 border-t border-white/10 pt-16" data-id="element-22">
          <p className="text-2xl italic text-gray-300 mb-8" data-id="element-23">
            "La clase que cambió a un alumno no fue la más creativa. Fue la más
            clara."
          </p>
          <p className="font-bold text-[#F0C14B] text-xl" data-id="element-24">
            — Método A.C.C.I.Ó.N.
          </p>
        </div>
      </div>
    </section>;
}